import { Stack } from "@mui/material";
import { WarningRounded } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReportTable from "../tables/ReportTable";
import { useRecoilState, useSetRecoilState } from "recoil";
import { STATE_REPORT_UPDATING, STATE_REPORT_UPLOADING } from "../constants/EnelxRecoil";

import FinanceDialog from "../../../component/FinanceDialog";
import ReportsFilter from "../filters/ReportsFilter";

function Reports() {

    const { t } = useTranslation('finance', { keyPrefix: 'enelx' });
 //   const { uploadReport } = useReportRepository();

  //  const { dispatchGlobalData } = useContext(GlobalContext);

    const setReportTableUpdating = useSetRecoilState(STATE_REPORT_UPDATING);
  //  const [reportUploading, setReportUploading] = useRecoilState(STATE_REPORT_UPLOADING);

    const [openUploadWarning, setOpenUploadWarning] = useState(false);
    const [uploadErrorMessage, setUploadErrorMessage] = useState<string>(t('import.error-dialog.errors.generic'));

    useEffect(() => {
        setReportTableUpdating(true);
    }, [])
/*
    useEffect(() => {
        if (reportUploading) {
            let fileExtension = reportUploading.name.split('.').pop();
            if (fileExtension!.toLowerCase() === "xlsx") {
                uploadReport(reportUploading)
                    .then(response => {
                        if (response.status === "OK") {
                            dispatchGlobalData({
                                type: setSnackbar,
                                payload: {
                                    snackbar: {
                                        message: t("snackbars.loading"),
                                        type: snackbarTypes.loading,
                                        show: true,
                                        autoClose: true,
                                    }
                                }
                            });
                            setReportTableUpdating(true);
                        } else {
                            if (response.message) {
                                if(response.message.startsWith("FieldValueParsingException")) {
                                   let message =  t("import.error-dialog.errors.import."+response.message.split("|")[0],
                                        {column : response.message.split("|")[1],
                                            line: response.message.split("|")[2]});
                                    setUploadErrorMessage(message);
                                    setReportTableUpdating(true);
                                }  else if(response.message.includes("errorFileStructure")){
                                    let message =  t("import.error-dialog.errors."+response.message.split("|")[0],
                                        {column : response.message.split("|")[1]});
                                    setUploadErrorMessage(message);
                                    setReportTableUpdating(true);
                                }else {
                                    setUploadErrorMessage(t(`import.error-dialog.errors.`+response.message, { reportName: reportUploading.name }));
                                }
                            } else {
                                setUploadErrorMessage(t('import.error-dialog.errors.generic'));
                            }
                            setOpenUploadWarning(true);
                        }
                    })
                    .finally(() => {
                        setReportUploading(undefined);
                    });
            } else {
                setUploadErrorMessage(t('import.error-dialog.errors.file-format-description'));
                setOpenUploadWarning(true);
                setReportUploading(undefined);
            }

        }
    }, [reportUploading])
    */
    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <ReportsFilter/>
            <ReportTable/>
            <FinanceDialog open={openUploadWarning} onClose={() => setOpenUploadWarning(false)} title={t('import.error-dialog.title')} cancelButton={t('import.error-dialog.close')}
                           content={uploadErrorMessage}
                           titleIcon={<WarningRounded color={"error"}/>}
            />
        </Stack>
    )
}

export default Reports;